import { render, staticRenderFns } from "./carFormTab.vue?vue&type=template&id=5b833777&scoped=true&"
import script from "./carFormTab.vue?vue&type=script&lang=js&"
export * from "./carFormTab.vue?vue&type=script&lang=js&"
import style0 from "./carFormTab.vue?vue&type=style&index=0&id=5b833777&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b833777",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b833777')) {
      api.createRecord('5b833777', component.options)
    } else {
      api.reload('5b833777', component.options)
    }
    module.hot.accept("./carFormTab.vue?vue&type=template&id=5b833777&scoped=true&", function () {
      api.rerender('5b833777', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/CarForm/carFormTab.vue"
export default component.exports